import { useState } from "react";
import { hotGroups } from "@/mocks/melon";

const NAV_ITEMS = [
  { label: "今日头条", href: "#top" },
  { label: "全网热榜", href: "#hot" },
  { label: "突发大事", href: "#breaking" },
  { label: "事件复盘", href: "#review" },
  { label: "吃瓜词典", href: "#dict" },
  { label: "栏目分类", href: "#category" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [kw, setKw] = useState("");

  const matches = kw.trim()
    ? hotGroups
        .flatMap((g) => g.list)
        .filter((it) => it.title.includes(kw.trim()) || it.tag.includes(kw.trim()))
        .slice(0, 6)
    : [];

  const goSearch = (title: string) => {
    setKw(title);
    setSearchOpen(false);
    const el = document.getElementById("hot");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-40 bg-background-50/90 backdrop-blur-md hdr-line">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        {/* 品牌 */}
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-900">瓜田日报</span>
            <span className="mt-0.5 text-[11px] tracking-wide text-foreground-500">全网热榜资讯站</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#newsletter"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅晚报
          </a>

          <button
            type="button"
            aria-label="搜索热点"
            onClick={() => setSearchOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-search-line text-lg" aria-hidden="true" />
          </button>

          {/* 移动端菜单按钮 */}
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-lg`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* 搜索面板 */}
      {searchOpen && (
        <div className="border-t border-background-200 bg-background-50">
          <div className="mx-auto max-w-7xl px-4 py-4 md:px-6">
            <div className="relative">
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-base text-foreground-400" aria-hidden="true" />
              <input
                autoFocus
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜索热榜事件、栏目或热词…"
                className="w-full rounded-lg border border-background-300 bg-background-50 py-3 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
              />
            </div>
            {matches.length > 0 && (
              <ul className="mt-3 overflow-hidden rounded-lg border border-background-200 bg-background-50">
                {matches.map((m) => (
                  <li key={m.title}>
                    <button
                      type="button"
                      onClick={() => goSearch(m.title)}
                      className="flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left text-sm text-foreground-800 transition-colors hover:bg-background-100"
                    >
                      <span className="flex items-center gap-2">
                        <span className="rounded bg-background-100 px-1.5 py-0.5 text-xs text-foreground-500">{m.tag}</span>
                        {m.title}
                      </span>
                      <span className="whitespace-nowrap text-xs text-foreground-400">{m.heat}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
            {kw.trim() && matches.length === 0 && (
              <p className="mt-3 text-sm text-foreground-500">没有找到与「{kw}」相关的热点，换个关键词试试。</p>
            )}
          </div>
        </div>
      )}

      {/* 移动端抽屉 */}
      {open && (
        <nav className="border-t border-background-200 bg-background-50 md:hidden" aria-label="移动端导航">
          <div className="mx-auto max-w-7xl px-4 py-2 md:px-6">
            {NAV_ITEMS.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-3 text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#newsletter"
              onClick={() => setOpen(false)}
              className="mt-2 block rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅晚报
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}